import {
  InvoiceAvInvoiceBillingInfoContactEmail,
  InvoiceID,
  InvoiceNanoID,
  InvoiceUUID,
  InvoiceUpdateAvInvoiceBillingInfoContactEmailCacheKeys,
  InvoiceUpdateAvInvoiceBillingInfoContactEmailGqlQuery
} from '../../invoicesTypes';

import { useCacheUpdateQuery } from '../../../common/reactQuery/hooks/useCacheUpdateQuery';

interface CacheInvoiceUpdateAvInvoiceBillingInfoContactEmailOptions {
  query: InvoiceUpdateAvInvoiceBillingInfoContactEmailGqlQuery;
  cacheKeys?: InvoiceUpdateAvInvoiceBillingInfoContactEmailCacheKeys;
}

export interface CacheInvoiceUpdateAvInvoiceBillingInfoContactEmailResponse {
  invoiceUpdateAvInvoiceBillingInfoContactEmail: {
    statusCode: number;
    message: string;
  };
}

export interface CacheInvoiceUpdateAvInvoiceBillingInfoContactEmailInput {
  uuid: InvoiceID | InvoiceUUID | InvoiceNanoID;
  contactEmail: InvoiceAvInvoiceBillingInfoContactEmail;
}

// TODO:
// Add error type for nest gql mutaion response
export type CacheInvoiceUpdateAvInvoiceBillingInfoContactEmailError = null;

const action = 'invoiceUpdateAvInvoiceBillingInfoContactEmail';

function useCacheInvoiceUpdateAvInvoiceBillingInfoContactEmail<
  CacheInvoiceUpdateAvInvoiceBillingInfoContactEmailRecordType = unknown
>({
  query,
  cacheKeys
}: CacheInvoiceUpdateAvInvoiceBillingInfoContactEmailOptions) {
  const {
    updateCacheQuery: invoiceUpdateAvInvoiceBillingInfoContactEmail,
    updateCacheQueryData: invoiceUpdateAvInvoiceBillingInfoContactEmailData,
    updateCacheQueryError: invoiceUpdateAvInvoiceBillingInfoContactEmailError,
    updateCacheQueryErrorMessage:
      invoiceUpdateAvInvoiceBillingInfoContactEmailErrorMessage,
    updateCacheQueryLoading:
      invoiceUpdateAvInvoiceBillingInfoContactEmailLoading,
    updateCacheQueryReset: invoiceUpdateAvInvoiceBillingInfoContactEmailReset
  } = useCacheUpdateQuery<
    CacheInvoiceUpdateAvInvoiceBillingInfoContactEmailInput,
    CacheInvoiceUpdateAvInvoiceBillingInfoContactEmailResponse,
    CacheInvoiceUpdateAvInvoiceBillingInfoContactEmailError,
    CacheInvoiceUpdateAvInvoiceBillingInfoContactEmailRecordType
  >({ action, query, cacheKeys });

  return {
    invoiceUpdateAvInvoiceBillingInfoContactEmail,
    invoiceUpdateAvInvoiceBillingInfoContactEmailData,
    invoiceUpdateAvInvoiceBillingInfoContactEmailError,
    invoiceUpdateAvInvoiceBillingInfoContactEmailErrorMessage,
    invoiceUpdateAvInvoiceBillingInfoContactEmailLoading,
    invoiceUpdateAvInvoiceBillingInfoContactEmailReset
  };
}

export default useCacheInvoiceUpdateAvInvoiceBillingInfoContactEmail;
